"use client";

import React from "react";
import CookieBanner from "./CookieBanner";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { CookieConsentProvider } from "@/lib/cookie-consent";

const CookieConsentManager: React.FC = () => {
  return (
    <CookieConsentProvider>
      <CookieBanner />
      <CookiePreferencesModal />
    </CookieConsentProvider>
  );
};

export default CookieConsentManager;
